<div class="navbar-container">
    <nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
        <div class="container">
            <input class="menu-btn" type="checkbox" id="menu-btn" />
            <label class="menu-icon navbar-brand" for="menu-btn"><span class="navicon"></span></label>

            <a class="navbar-brand" [hidden]="!showToPageTop" [translate]="'navbar.page_top'" (click)="utils.scrollToElement('body')"></a>

            <!--div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item ml-auto" *ngFor="let item of items">
                        <a class="nav-link" *ngIf="item.isInPageNavigateNavbarItem" [translate]="item.translate" [attr.scrollToElementId]="item.scrollToElementId" (click)="utils.scrollToElement(item.scrollToElementId)"></a>
                        <a class="nav-link" *ngIf="item.isSiteUrlNavigateNavbarItem" [translate]="item.translate" [attr.siteUrlNavigation]="true" [routerLink]="[item.url]"></a>
                    </li>
                </ul>
            </div-->
            <div href="" class="force-menu-to-right-side"></div>
            <ul class="menu">
                <li class="navbar-brand" *ngFor="let item of items">
                    <a *ngIf="isInPageItem(item)" [translate]="item.translate" [attr.scrollToElementId]="item.scrollToElementId" (click)="utils.scrollToElement(item.scrollToElementId)"></a>
                    <a *ngIf="isSiteUrlItem(item)" [translate]="item.translate" [attr.siteUrlNavigation]="true" [routerLink]="[item.url]"></a>
                </li>
            </ul>
        </div>
    </nav>
</div>
